import { ChangeDetectionStrategy, Component, input, output, inject } from '@angular/core';
import { DirectsState, PermissionsService, CoinAppsOverviewComponent } from '@coin/shared/auth/feature';
import { environment } from '@coin/shared/core/util-environments';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'customer-app-apps',
  templateUrl: './apps.component.html',
  styleUrls: ['./apps.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CoinAppsOverviewComponent, AsyncPipe, TranslatePipe]
})
export class AppsComponent {
  private readonly directsState = inject(DirectsState);

  // eslint-disable-next-line @angular-eslint/no-output-native
  toggle = output();
  closeMenu = output();
  isExpanded = input(false);

  isLineManager = this.directsState.isLineManager;
  isHead$ = inject(PermissionsService).isHead$;

  public environment = environment;
}
